import script from "./MarcaProductoTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarcaProductoTable.vue?vue&type=script&setup=true&lang=ts"

import "./MarcaProductoTable.vue?vue&type=style&index=0&id=7fa0fa4a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fa0fa4a"]])

export default __exports__